import { render, staticRenderFns } from "./ReactionsModal.vue?vue&type=template&id=12f23abc&"
import script from "./ReactionsModal.vue?vue&type=script&lang=js&"
export * from "./ReactionsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports